// extracted by mini-css-extract-plugin
export default {"NearbyAirports":"NearbyAirports_NearbyAirports__YmNkN","list":"NearbyAirports_list__YmQzN"};